export default "__VITE_ASSET__wgaD0NAs__"